export enum OccasionalTransportMode {
  Off = 0,
  ForBus = 1,
  On = 2,
}
